import React, { FC } from 'react';
import { DirectoryBar } from '../components/DirectoryBar';
import { H1 } from '../components/H1';
import { H5 } from '../components/H5';

export const CorporateResponsibilityPage = () => {
  return (
    <>
      <DirectoryBar text="홈, 기업의 사회적 책임" />
      <div className="max-w-3xl mx-auto space-y-12 pb-20 pt-10">
        <H1 className="font-bold text-center md:pb-10">
          기업의 사회적 책임
        </H1>

        <div className="">
          <CPItem
            title="개요"
            content="적의 근무 환경, 그리고 노조와의 협의를 통한 공정한 임금을 지불해왔습니다. “오로지 이익만을 목표로 하기보다는, 정직하고 옮은 일을 하며 그 안에서 가능한 이익을 얻는 것이 목표다.” 라고 그는 말하고는 했습니다. 이처럼 Hamilton Carhartt는 광부, 사냥꾼, 건설 및 공장 근로자처럼 열심히 일하는 사람들이 안심하고 입을 수 있는 옷을 만들기 위해 높은 퀄리티의 소재를 사용하는 것을 브랜드의 시작부터 고집해왔습니다. 우리는 이를 자랑스럽게 여기며, 계속해서 그 가치를 이어 나가기 위해 매일 노력하고 있습니다. 아래의 세가지 주제로 구분하여 Carhartt WIP의 사회적 책임을 말하고자 합니다."
          />
          <div className="space-y-4 pt-7 pl-9">
            <div className="flex space-x-2">
              <p>•</p>
              <button className="underline text-gray-500">
                <a href="#CPI_PD">Product (상품)</a>
              </button>
            </div>
            <div className="flex space-x-2">
              <p>•</p>
              <button className="underline text-gray-500">
                <a href="#CPI_PD2">Production (생산)</a>
              </button>
            </div>
            <div className="flex space-x-2">
              <p>•</p>
              <button className="underline text-gray-500">
                <a href="#CPI_OR">Operations (운영)</a>
              </button>

            </div>
          </div>
        </div>
        <div id="CPI_PD" className="pt-14">
          <CPItem
            title="PRODUCT (상품)"
            content="개개인의 탄소 배출량을 줄이는 가장 효과적인 방법은 불필요한 소비를 줄이고, 환경을 생각하는 제품을 소비하는 것입니다. Carhartt WIP의 환경보호에 관한 근본적인 노력은 오랜 시간 사용 가능한 내구성 높은 제품에 녹아 있습니다. 정직함을 담은 Carhartt WIP의 워크웨어는 패스트 패션의 트렌드에서 벗어나 긴 시간 동안 사랑받고 있습니다. 오늘의 Carhartt WIP는 편안하고 트렌드에 구애 받지 않는 디자인과 높은 품질의 원단을 통해 Hamilton Carhartt가 중요시 했던 튼튼한 워크웨어에 대한 기준을 이어가고 있습니다."
          />
        </div>
        <CPItem
          title="Cotton (면 소재)"
          content="Carhartt WIP 시즌 컬렉션 절반 이상의 제품은 코튼으로 만들어집니다. 물론 코튼은 천연 소재로 자연 분해가 가능하지만, 일반적인 코튼의 재배 방식은 환경과 사회에 큰 영향을 미칩니다. 대표적인 예로, 코튼을 생산해내기 위해서는 많은 양의 해로운 살충제를 사용하게 되는데, 이는 소규모로 코튼을 재배하는 물론 코튼은 천연의 생 분해 가능한 소재이지만, 일반적인 재배 방식은 환경과 사회에 큰 영향을 미칩니다. 대표적인 예로, 코튼을 생산해내기 위해서는 많은 양의 해로운 살충제를 사용해야 하는 경우가 많은데, 이는 소규모 농장을 운영하는 농민들에게 경제적인 측면에서 많은 부분을 차지하는 요소입니다. Carhartt WIP는 이러한 부정적 영향을 효과적으로 줄이는 노력의 일환으로 두 가지 측면에서 접근하고 있습니다.
"
        />

        <div className="pl-9 space-y-12">
          <p className="leading-7">
            <span className="font-bold">a.Organic Cotton</span> - 2017년부터
            Carhartt WIP는 Carhartt WIP만의 독특한 Dearborn Canvas를 큰 변화의
            시작으로 삼아 자연친화적으로 자란 코튼을 사용해오고 있습니다. 독한
            살충제를 사용하지 않는 오가닉 코튼은 농부들의 건강, 환경, 전반적인
            노동 조건을 향상시켰고, 토양의 품질과 영양분을 높이는 데에 많은
            도움을 주었습니다. 2020년도 봄/여름 시즌을 시작으로 Carhartt WIP의
            모든 Dearborn Canvas 제품들은 오가닉 코튼으로 만들어지며, 모든
            과정이 친환경적이고 에너지를 효율적으로 활용하는 방법으로 이루어지고
            있습니다. 이 제품에는 특별한 라벨이 부착되어 있으며, 가까운 미래에는
            오가닉 코튼을 기반으로 한 많은 제품들을 이어서 선보일 예정입니다.
          </p>
          <p className="leading-7">
            <span className="font-bold">b. Better Cotton Initiative (BCI)</span>{' '}
            - Carhartt WIP는 글로벌 코튼 생산의 발전에 보탬이 되기 위해 2017년
            5월부터 “Better Cotton Initiative (BCI)”의 일원으로써 함께 해오고
            있습니다. BCI는 비영리 단체로, 글로벌 코튼 분야의 더 나은 환경을
            위해 새로운 기준을 제시하는 역할을 하고 있습니다. 현재까지 BCI와
            파트너들은 220만명, 21개 목화 재배 국가들에게 코튼 생산이 지속
            가능한 재배 방법으로 유지될 수 있도록 교육을 제공해왔습니다.
            Carhartt WIP는 우리가 사용하고 있는 오가닉 코튼이 꾸준하게 공급될 수
            있도록 Better Cotton을 매년 지속적으로 돕고 있습니다.
          </p>
        </div>

        <CPItem
          title="Restricted Substances List (제한 물질 목록)"
          content="
코튼을 포함한 Carhartt WIP의 모든 제품은 상세한 전문 테스트 과정을 통과해야 함과 동시에 엄격한 규정 또한 준수해야 합니다. Carhartt WIP의 “제한 물질 목록 (RSL)”은 유해한 화학물질의 사용을 방지하여 고객의 건강과 환경을 보호하는데 도움을 줍니다. 국제 법과 규정에 따르면, 제한 물질 목록은 화학 물질 관리에 대한 기준을 제시하며, 이는 매년 개정/수정 됩니다. Carhartt WIP는 이러한 규정을 준수하기 위해서 협력업체가 “제한 물질 목록 (RSL)”을 인지할 수 있도록 긴밀히 협력하고, 매 시즌 마다 제품을 테스트 하고 있습니다."
        />
        <CPItem
          title="Finishing (마감처리)"
          content="Carhartt WIP의 팬츠는 디자인을 위해 다양한 생산 공정을 거치게 됩니다. 2017년부터 우리는 EIM (Environmental Impact Measuring) 소프트웨어를 사용하기 시작했는데, 이는 Carhartt WIP가 사용하고 있는 모든 마감 공정 기술들이 환경에 미치는 영향을 평가하기 위 함입니다. 80% 이상의 Carhartt WIP 하의 제품들은 “rigid” 또는 “rinsed” 등의 가공을 거치는데, 이는 제품들이 가공되지 않았거나, 한 번 세탁되었다는 의미로써 환경에 비교적 적은 영향을 미칩니다. 그러나 나머지 20%의 제품들은 이처럼 만족스러운 결과를 얻지 못했습니다. 그래서 우리는 현재 환경 지속성을 고려하며 생산을 최대한 높일 수 있는 대체 기술과 가능성들을 테스트 중에 있습니다."
        />
        <CPItem
          title="Other Sustainable Fibers (지속 가능한 섬유)"
          content="Carhartt WIP는 원단 공급 업체들 과의 적극적인 협력을 통해 Carhartt WIP의 품질과 내구성 기준에 맞는 다양한 지속 가능한 대체 섬유들을 모색하고 있습니다. Carhartt WIP는 지속 가능성을 기준으로 삼아 더 발전할 수 있는 기회를 위해 다양한 기술들을 꾸준히 검토해오고 있습니다."
        />
        <div id="CPI_PD2" className="pt-14">
          <CPItem
            title="PRODUCTION (생산)"
            content="세계화가 가중되고 있는 사회에서 Carhartt WIP를 비롯한 많은 의류 브랜드들은 복잡한 원단 공급망으로 인해 생산 과정에 많은 어려움을 겪고 있습니다. 그리고 치열한 경쟁과 더불어 시장 내의 패스트 패션 가격 정책으로 인해 전 세계의 여러 공장과 생산 현장에는 여러 문제점들이 발생하고 있습니다. 이로 인해 우리는 Carhartt WIP의 생산지와 협력 업체들에 많은 관심을 가지게 되었습니다. 효율적이고 환경 친화적인 건전한 생산 현장을 지키기 위해, Carhartt WIP는 협력업체들 과의 신뢰와 상호 존중을 기반으로 장기적인 관계를 이어오고 있음과 동시에 정기적인 현장 점검 또한 해오고 있습니다."
          />
        </div>
        <CPItem
          title="Production Countries (생산 국가)"
          content="Carhartt WIP 컬렉션의 3분의 1에 해당하는 제품들은 2004년에 지어진 Carhartt WIP의 튀니지아 공장에서 만들어집니다. 공장 설립부터 Carhartt WIP는 700명 가까이 되는 직원들의 편안함과 복지를 최우선으로 삼아 운영해오고 있습니다. 대중교통이 열악한 지역으로, Carhartt WIP는 통근 버스를 마련하여 직원들의 출퇴근을 돕고 있습니다. 2014년도 Carhartt WIP는 SA8000 인증을 받게 되었는데, 이 시스템은 사회 보장 제도를 위해 만들어진 관리 시스템으로 근로 현장의 환경을 모니터링 하는데 도움을 주고 있습니다. Carhartt WIP 제품의 대부분은 유럽에서 생산된 원단으로 만들어집니다. 또한, 중국, 캄보디아, 베트남, 인도, 파키스탄, 방글라데시 등의 지역과도 긴밀한 협력 관계를 유지해오고 있습니다. 흔한 선입견에도 불구하고, 이 지역에는 높은 수준의 설비를 갖춘 공장들이 여러 있습니다. Carhartt WIP는 점심 식사, 교통, 보육, 의료 서비스 등과 같은 직원들의 이익을 우선으로 하여 협력 업체를 선정해오고 있습니다."
        />
        <CPItem
          title="Supplier Monitoring (협력업체 모니터링)"
          content="Carhartt WIP는 우리의 기업 가치를 함께 공유하고, 계속해서 발전하고 개선해 나갈 수 있는 회사들과 협력하고 있습니다. Carhartt WIP는 협력업체들이 윤리 강경 가이드 라인을 지킬 수 있도록 돕고 있습니다. Carhartt WIP의 윤리 강경 가이드 라인은 국제 노동 기구의 핵심 협약인 세계 인권 선언을 비롯한, 국제적으로 통용되는 노동 기준을 바탕으로 정립되었습니다. 협력업체 뿐만 아니라 그들의 하도급 업체들 또한 이 가이드 라인을 함께 지켜 나갈 수 있도록 적극적으로 지원하고 있습니다. * (윤리 강경 가이드 라인의 최근 개정 내용은 아래의 CODE OF CONDUCT에서 확인 할 수 있습니다. - 2018/10/03 개정) Carhartt WIP는 이러한 핵심적인 원칙들이 함께 일하고 있는 전세계 45개의 협력업체에서 꾸준히 유지될 수 있도록 엄격한 모니터링 시스템을 구축했습니다. 이 시스템은 경영진과 근로자들 과의 심도 있는 면담과 공장의 설비 검사, 그리고 모든 서류와 기록물에 대한 철저한 검토를 포함하고 있습니다. 감사 보고서로 확인하기 어려운 부분들은 내부 전문가로 꾸려진 팀을 구성하여 협력업체들을 방문하여 확인하고 직접적인 도움을 줄 수 있도록 하였습니다. Carhartt WIP는 개방적이고 투명한 대화를 통해 협력업체들과 함께 발전하고자 합니다."
        />

        <div className="space-y-6">
          <div className="pt-14" id="CPI_OR">
            <CPItem
              title="OPERATIONS (운영)"
              content="사회적 또는 환경적 영향은 대부분 제품의 생산 과정에서 발생 합니다. 하지만 Carhartt WIP는 우리의 ‘집’에서부터 그 책임을 다하기로 하였습니다. 독일의 ‘바일 암 라인’이라는 도시에 위치하고 있는 Carhartt WIP 본사와 물류 창고에서는 물류 시스템을 최적화 하고 대부분의 에너지를 재생 가능한 자원으로 활용하여 효율적으로 운영해오고 있습니다."
            />
          </div>

          <p className="leading-7">
            <span className="font-bold">Logistics (물류창고) </span>- Carhartt
            WIP의 물류창고는 불필요한 폐기물이나 쓰레기를 줄이기 위한 최첨단
            기술을 갖추고 있습니다. 제품의 포장과 발송에 사용되는 모든 박스들은
            재활용 소재를 사용하였습니다. 해외 수출의 경우에는 해상 운송을
            이용하며, 예외적인 경우에만 일부 항공 운송을 이용하고 있습니다. 또한
            해상 운송시에도 선적 이전에 컨테이너가 가득 채워졌는지 한 번 더 확인
            하는 과정을 거치고 있습니다.
          </p>
          <p className="leading-7">
            <span className="font-bold">Green Energy (녹색 에너지)</span>-
            Carhartt WIP는 2005년도부터 독일 ‘바일 암 라인’에 위치해 있는
            Carhartt WIP 본사, 물류창고 그리고 아울렛 스토어 건물 옥상을 태양광
            패널로 교체하는 일을 해오고 있으며, 현재는 약 10,000m2에 가까운
            면적에 태양광 패널이 설치되어 있습니다. 이를 통해 매년 약 130만
            kWh의 전력을 생산하고 있으며, 이는 독일의 약 430개 일반 가정이
            사용하기에 충분한 양입니다. Carhartt WIP는 독일의 재생 에너지 관련
            법규에 따라, 태양광 패널로 생산한 전기를 일반 가정용 보급 네트워크에
            공급하고 있습니다. Carhartt WIP는 여기서 멈추지 않고, 환경에 미치는
            영향을 더욱 줄이기 위해 그 노력의 일환으로 에너지 소비에 대해 신중한
            선택을 하고, 현재 Carhartt WIP의 본사에서는 수력 발전으로 생산된
            전력만 소비하고 있습니다.
          </p>
        </div>

        <div className="space-y-6">
          <CPItem
            title="CODE OF CONDUCT (행동 강령)"
            content="Carhartt WIP는 프리미엄 브랜드로써 공평하고 윤리적인 방향으로 브랜드를 운영하기 위해 최선을 다해오고 있습니다. 따라서 우리는 Carhartt WIP의 내에서 뿐만 아니라 협력 관계를 맺고 있는 업체에 윤리 강경 가이드 라인을 만들어 이를 지킬 수 있도록 돕고 있습니다. 이 가이드 라인은 국제 노동 기구의 핵심 협약인 세계 인권 선언을 비롯한 국제적으로 통용되는 노동 기준을 바탕으로 정립되었습니다. Carhartt WIP는 윤리 강경 가이드 라인을 통해 최소한의 기준을 바로잡는 동시에 Carhartt WIP의 가치를 존중해주며, 발전과 환경을 위해 끊임없이 헌신하는 기업들과 함께 협력해 나가고자 합니다. * (‘협력업체’는 Carhartt WIP 전반적인 운영 과정에서 함께하는 여러 파트너 들을 포괄적으로 지칭하는 용어입니다. – 의류 봉제, 원단 공급, 부자재 및 원료 공급, 라이선스 파트너, 물류 및 운송 업체 등)"
          />
          <p className="leading-7">
            <span className="underline">
              Employment Relationship (고용 관계)
            </span>{' '}
            - Carhartt WIP는 2005년도부터 독일 ‘바일 암 라인’에 위치해 있는
            Carhartt WIP 본사, 물류창고 그리고 아울렛 스토어 건물 옥상을 태양광
            패널로 교체하는 일을 해오고 있으며, 현재는 약 10,000m2에 가까운
            면적에 태양광 패널이 설치되어 있습니다. 이를 통해 매년 약 130만
            kWh의 전력을 생산하고 있으며, 이는 독일의 약 430개 일반 가정이
            사용하기에 충분한 양입니다. Carhartt WIP는 독일의 재생 에너지 관련
            법규에 따라, 태양광 패널로 생산한 전기를 일반 가정용 보급 네트워크에
            공급하고 있습니다. Carhartt WIP는 여기서 멈추지 않고, 환경에 미치는
            영향을 더욱 줄이기 위해 그 노력의 일환으로 에너지 소비에 대해 신중한
            선택을 하고, 현재 Carhartt WIP의 본사에서는 수력 발전으로 생산된
            전력만 소비하고 있습니다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Compliance with Laws and Workplace Regulations (법률 및 작업장
              규정 준수)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 고용, 사회 보장,
            보건 및 안전성, 환경과 연관된 모든 장소에서 법률 및 규정을
            준수하여야 한다. 또한 협력업체와 공인된 하도급업체들은 Carhartt
            WIP가 운영되고 있는 국가에서 적용되는 현지 법률을 준수하기 위해
            Carhartt WIP와 전적으로 협력해야 한다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Prohibition of Forced labour (부당 노동 금지)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 강제, 사기, 착취
            등의 비자발적 노동자 또는 부당 착취로 얻어낸 노동자를 고용하지
            않는다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Prohibition of Child Labour (아동 노동 금지)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 의무 교육 연령인
            만 15세 미만의 아동과 법이 기준하는 최소 근로 연령 미만의 직원을
            고용하지 않는다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Prohibition of Harassment or Abuse (괴롭힘 금지)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 모든 근로자들이
            존중 받고 품위 있는 대우를 받을 수 있는 근무 환경 조성을 위해
            노력해야 한다. 어느 근로자도 신체적, 성적, 정신적 또는 언어적
            괴롭힘, 학대 또는 체벌을 받을 수 없다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Compensation and Benefits (보상 및 혜택)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 법정 임금, 수당
            및 복리후생비를 포함한 현지 법률이 규정한 최저 임금을 지급하여야
            한다.
          </p>
          <p className="leading-7">
            <span className="underline">Hours of Work (근무 시간)</span> -
            Carhartt WIP의 협력업체와 공인된 하도급 업체들은 현지 법률이 규정한
            근로 시간을 준수 하여야 한다. 협력업체는 긴급한 경우를 제외하고 7일
            마다 최소 1일 (24시간)의 휴가를 제공하여야 한다. 협력업체는 모든
            근로자의 주당 총 근로시간을 60시간으로 제한하고, 자발적으로 근무하는
            경우에만 초과근무를 허용한다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Prohibition of Discrimination (차별 금지)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 근로자 개인의
            성향이나 신념이 아닌 오직 업무 수행 능력에 따라 근로자를 고용, 보상,
            승진 및 해고 할 수 있다. 어느 근로자도 직장 내에서 성, 민족, 종교,
            나이, 장애, 성적 지향, 국적, 정치적 신념, 사회 집단 또는 출신 인종에
            따라 차별의 대상이 될 수 없다. 또한, 어떤 개인적 성향도 근로자의
            고용, 임금, 승진, 문책, 해고, 사임에 영향을 미칠 수 없다.
          </p>
          <p className="leading-7">
            <span className="underline">Health and Safety (건강과 안전)</span> -
            Carhartt WIP의 협력업체와 공인된 하도급 업체들은 안전하고 건강한
            근로 환경을 제공하여야 한다. 이는 근로자들의 사고를 예방하고, 시설
            운영 중 발생하는 부상을 방지하기 위함이다. 또한, 여러 세입자가 있는
            다층 공장에서 Carhartt WIP의 생산은 금지한다. 근로자들에게 숙소가
            제공되는 경우, 협력업체는 숙소가 안전한 환경을 갖추고 있는지
            확인하여야 하는 책임이 있다.
          </p>

          <p className="leading-7">
            <span className="underline">
              Freedom of Association & Collective Bargaining (노조의 자유와 단체
              교섭)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 근로자들의 결사의
            자유 및 단체 교섭에 대한 권리를 인정하고 존중하여야 한다.
          </p>
          <p className="leading-7">
            <span className="underline">Environmental (환경)</span> - Carhartt
            WIP의 협력업체와 공인된 하도급 업체들은 운영 과정에 있어 환경 관련
            법규, 규정과 기준을 따라야 하며, 근로 환경이 환경에 미치는 부정적인
            영향을 완화하기 위한 책임 있는 조치를 취하여야 한다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Customs Compliance (세관 규정 준수)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 관세 법률을
            준수하고, 의류 불법 반출과 관련한 법규를 준수할 수 있도록 장치를
            마련하고 유지 관리해야 한다.
          </p>
          <p className="leading-7">
            <span className="underline">Security (보안)</span> - Carhartt WIP의
            협력업체와 공인된 하도급 업체들은 해외에서 수입되는 제품 중 미등록
            화물 (예: 마약, 폭발물, 생화학 물질 또는 기타 밀수품)이 들어오는
            것을 예방하기 위해 공장 시설에 대한 시설 보안 절차를 마련 및 관리
            해야 한다. 협력업체는 또한 Carhartt WIP와 함께 협력하여 Authorized
            Economic Operator (AEO: 공인 수출입 안전관리 우수기업) 보안 및 안전
            기준을 준수하여야 한다.
          </p>
          <p className="leading-7">
            <span className="underline">
              Bribery and Corruption (뇌물과 부정부패)
            </span>{' '}
            - Carhartt WIP의 협력업체와 공인된 하도급 업체들은 Carhartt WIP와
            맺은 협력 관계와 관련하여, 어떠한 경우에도 직간접적으로 뇌물 또는
            기타 부적절한 혜택을 제공하여 기타 개인, 회사, 조직, 정부 기관, 정당
            또는 선거 후보자에게 영향력을 행하여서는 안 된다. 위의 윤리 강경
            가이드 라인의 내용과 같이, Carhartt WIP는 우리의 가치를 함께 공유할
            수 있으며, 사회적 및 환경적 관행을 지속적으로 개선하기 위해 노력하는
            기업들과 협력하기를 희망합니다. 본 윤리 강경 가이드 라인에 설명된
            기준들을 Carhartt WIP 제품의 제작, 생산, 운송에 함께하는 전세계의
            모든 협력업체들과 지켜 나가고자 합니다. Carhartt WIP와 직접 협력
            관계를 맺고 있는 계약된 협력업체들은 이 윤리 강경 가이드 라인을
            하도급 업체들에게 공유함으로써, Carhartt WIP가 추구하는 기준들이
            자리 잡아 나가기를 희망합니다.
          </p>
        </div>
      </div>
    </>
  );
};

interface CPItemProps {
  title: string;
  content: string;
}

export const CPItem: FC<CPItemProps> = ({ title, content }) => {
  return (
    <>
      <div className="space-y-6">
        <H5 className="">{title}</H5>
        <p className="leading-7">{content}</p>
      </div>
    </>
  );
};
